import { BubbleView } from "./BubbleView"
import { BubbleViewCfg } from "./useBubbleNotes"

const tweakCfg:BubbleViewCfg = {
  editTweaks:true
}

export const BubbleTweakView =  () => <BubbleView cfg={tweakCfg}/>

